var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppTableRow',_vm._b({class:{
    blink: _vm.source.display.animate,
    unblink: !_vm.source.display.animate,
  },staticStyle:{"--row-h":"4rem"},attrs:{"source":_vm.source,"showActionsMenu":['Ready', 'Building', 'Finished', 'Running', 'Stopped'].includes(
      _vm.source.status
    )},on:{"showMenu":_vm.showMenu},scopedSlots:_vm._u([{key:"createdAt",fn:function(ref){
    var createdAt = ref.source.createdAt;
return [_c('p',{staticClass:"text-base text-dark"},[_vm._v(_vm._s(_vm._f("date")(createdAt)))])]}},{key:"scope_application",fn:function(ref){
    var application = ref.source.display.application;
return [_c('Icon',{staticClass:"text-dark w-5 h-5 ml-6",attrs:{"icon":application.icon,"title":application.name}})]}},{key:"scope_findingTypes",fn:function(ref){
    var findings = ref.source.display.findings;
return [_c('div',{staticClass:"flex-col flex gap-1"},_vm._l((findings),function(f){return _c('p',{key:f,staticClass:"text-base text-dark"},[_vm._v(" "+_vm._s(f)+" ")])}),0)]}},{key:"scope_labelIds",fn:function(ref){
    var information = ref.source.display.information;
return [(information[0])?_c('div',{staticClass:"flex flex-row items-center gap-2"},[_c('Icon',{staticClass:"text-dark w-5 h-5",attrs:{"icon":_vm._f("l0IconByCode")(information[0].code)}}),_c('p',{staticClass:"text-base text-dark"},[_vm._v(_vm._s(information[0].labelName))])],1):_c('p',{staticClass:"text-base text-dark pl-6"},[_vm._v("Any")])]}},{key:"scope_itemsCount",fn:function(ref){
    var itemsCount = ref.source.scope.itemsCount;
return [_c('div',{staticClass:"flex flex-row items-center pl-6 gap-2"},[_c('p',{staticClass:"text-base text-dark"},[_vm._v(_vm._s(itemsCount))])])]}},{key:"status",fn:function(ref){
    var ref_source = ref.source;
    var status = ref_source.status;
    var runtimeScope = ref_source.runtimeScope;
return [_c('div',{staticClass:"flex flex-row items-center  gap-2"},[_c('div',{staticClass:"w-2 h-2 rounded-full",class:{
          'bg-gray-500': status === 'New',
          'bg-level-m': status === 'BuildScheduled' || status === 'Building',
          'bg-primary': status === 'Ready',
          'bg-level-m-bold':
            status === 'RunScheduled' || status === 'Running',
          'bg-level-l': status === 'Finishing' || status === 'Finished',
          'bg-level-h':
            status === 'StopScheduled' ||
            status === 'Stopping' ||
            status === 'Stopped' ||
            status === 'Terminated' ||
            status === 'Terminating',
          blink: [
            'BuildScheduled',
            'Building',
            'RunScheduled',
            'Finishing',
            'StopScheduled',
            'Stopping',
            'Running',
            'New',
            'Terminating' ].includes(status),
          unblink: ['Ready', 'Finished', 'Terminated', 'Stopped'].includes(
            status
          ),
        }}),_c('p',{staticClass:"text-base text-dark font-medium"},[_vm._v(_vm._s(_vm.readable_status))]),(status === 'Terminated' && runtimeScope.reason)?_c('Icon',{directives:[{name:"tooltip",rawName:"v-tooltip:top",value:(runtimeScope.reason),expression:"runtimeScope.reason",arg:"top"}],staticClass:"text-dark w-5 h-5",attrs:{"icon":"Info"}}):_vm._e(),_c('div',{staticClass:"flex-1"}),(status == 'Ready')?_c('button',{staticClass:"flex flex-row items-center justify-center mr-4 bg-primary rounded-full w-10 h-10 shadow-lg hover:shadow-xl transition-all duration-200",on:{"click":_vm.generate_script}},[_c('Icon',{directives:[{name:"tooltip",rawName:"v-tooltip:left",value:('Generate Script'),expression:"'Generate Script'",arg:"left"}],staticClass:"text-light w-6 h-6",attrs:{"icon":"Play"}})],1):_vm._e()],1)]}}])},'AppTableRow',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }